import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reject",
  "use": "icon-reject-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-reject\">\r\n<g>\r\n\t<path d=\"M46.5,119.3c0,29.5,24,53.5,53.5,53.5c12.3,0,23.7-4.2,32.8-11.3l-75-75C50.7,95.6,46.5,107,46.5,119.3z\" />\r\n\t<path d=\"M100,65.8c-12.3,0-23.7,4.2-32.8,11.3l75,75c7-9.1,11.3-20.4,11.3-32.8C153.5,89.8,129.5,65.8,100,65.8z\" />\r\n\t<path d=\"M172.9,9.7c-2.5-3.8-6.8-6.2-11.4-6.2H38.2c-4.6,0-8.9,2.3-11.4,6.2L3.5,44.9v137.9c0,7.6,6.2,13.8,13.8,13.8h165.4\r\n\t\tc7.6,0,13.8-6.2,13.8-13.8V44.9L172.9,9.7z M100,186.2c-36.9,0-66.9-29.9-66.9-66.9c0-18.5,7.5-35.2,19.6-47.3c0,0,0,0,0,0\r\n\t\tc0,0,0,0,0,0C64.8,59.9,81.5,52.4,100,52.4c36.9,0,66.9,29.9,66.9,66.9C166.9,156.2,136.9,186.2,100,186.2z M17.3,44.9L17.3,44.9\r\n\t\tl20.1-27.4l125.5-0.1l19.9,27.6L17.3,44.9z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/reject.svg
// module id = Mql9
// module chunks = 171